"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.axios = void 0;
var axios_1 = __importDefault(require("axios"));
var axios = axios_1.default.create({
    baseURL: window.location.origin + "/wp-json/wp/v2/",
    timeout: 60000,
});
exports.axios = axios;
axios.interceptors.request.use(function (config) {
    /** In dev, intercepts request and logs it into console for dev */
    console.info("✉️ ", config);
    return config;
}, function (error) {
    console.error("✉️ ", error);
    return Promise.reject(error);
});
var api = {
    getPosts: function (postType, postObj) {
        var config = {
            page: postObj.page,
            per_page: postObj.per_page,
            search: postObj.search,
            orderby: postObj.orderby,
            order: postObj.order,
        };
        if (postObj && postObj.categories) {
            postObj.categories.forEach(function (cat) {
                if (cat.id !== -1) {
                    config[cat.name] = cat.id;
                }
            });
        }
        console.log("Searching with options: ", config);
        return axios.get(postType, {
            params: config
        }).then(function (response) {
            console.log("Posts: ", response.data);
            return response.data;
        });
    },
    getPostsTotal: function (postType, postObj) {
        var config = {
            page: postObj.page,
            per_page: postObj.per_page,
            search: postObj.search,
            orderby: postObj.orderby,
            order: postObj.order,
        };
        if (postObj && postObj.categories) {
            postObj.categories.forEach(function (cat) {
                if (cat.id !== -1) {
                    config[cat.name] = cat.id;
                }
            });
        }
        return axios.get(postType, {
            params: config
        }).then(function (response) {
            var _a, _b;
            console.log("Totals headers: ", response.headers);
            var totals = {
                totalPages: (_a = parseInt(response.headers['x-wp-totalpages'])) !== null && _a !== void 0 ? _a : 10,
                totalPosts: (_b = parseInt(response.headers['x-wp-total'])) !== null && _b !== void 0 ? _b : 100,
            };
            return totals;
        });
    }
};
exports.default = api;
